module.exports = __webpack_public_path__ + "static/typewriter-5948b22da7e74e4f26a0d45e82681657.svg";